module.exports = __webpack_public_path__ + "img/search.1ac46e5b.png";